// extracted by mini-css-extract-plugin
export var inlineLink = "_43-0";
export var inlineLinkButton = "_43-1";